<template>
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.70137 11C2.70137 6.41699 6.41662 2.70173 10.9996 2.70173C15.5826 2.70173 19.2979 6.41699 19.2979 11C19.2979 15.583 15.5826 19.2983 10.9996 19.2983C6.41662 19.2983 2.70137 15.583 2.70137 11ZM10.9996 0.901733C5.42251 0.901733 0.901367 5.42288 0.901367 11C0.901367 16.5771 5.42251 21.0983 10.9996 21.0983C16.5767 21.0983 21.0979 16.5771 21.0979 11C21.0979 5.42288 16.5767 0.901733 10.9996 0.901733ZM14.6193 9.73939C14.9707 9.38792 14.9707 8.81807 14.6193 8.4666C14.2678 8.11513 13.6979 8.11513 13.3465 8.4666L10.1889 11.6242L8.65282 10.0882C8.30134 9.73668 7.7315 9.73668 7.38002 10.0882C7.02855 10.4396 7.02855 11.0095 7.38002 11.3609L9.55246 13.5334C9.72125 13.7022 9.95017 13.797 10.1889 13.797C10.4276 13.797 10.6565 13.7022 10.8253 13.5334L14.6193 9.73939Z"
      fill="var(--color-toast-success-icon)"
    />
  </svg>
</template>
